angular.module('cfn').controller('ConfirmModalPersistentController', [
  '$scope',
  'dialog',
  'model',
  'UserSessionStorageService',
  function($scope, dialog, model, UserSessionStorageService) {
    $scope.title = model.title;
    $scope.dontAskAgain = false;
    $scope.message = model.message;
    $scope.buttons = model.buttons;

    /**
     * saves dont ask again boolean to session storage
     * @param  {string} namespace
     */
    function saveDontAskAgain(namespace) {
      var storage = UserSessionStorageService.createStorage(
        'confirmModalPersistent'
      );
      var storageData = storage.load() || {};
      storageData[namespace] = true;
      storage.save(storageData);
    }

    /**
     * modal close callback
     * @param  {string} res
     */
    $scope.close = function(res) {
      if (res === 'ok' && $scope.dontAskAgain) {
        saveDontAskAgain(dialog.options.namespace);
      }
      dialog.close(res);
    };
  }
]);
